import {z} from 'zod';

/**
 * Response schema for getting file as base64 from storage service
 */
export const storageFileResponseSchema = z.object({
  base64: z.string(),
  contentType: z.string(),
  size: z.number().int(),
  filename: z.string().optional(),
});

export type StorageFileResponse = z.infer<typeof storageFileResponseSchema>;
